import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addActiveLegal } from "~/redux/actions/legal";
import { ReduxState } from "~/types/redux";

interface Props {
  legalKey: string;
  className?: string;
  testId?: string;
}

/**
 * This component will render a number in a superscript tag
 * The number dynamically updates to ensure it matches the approprate legal disclaimer in the footer
 * @param {string} legalKey - key to a legal object in the legal response from the OL
 * @param {string} className - optional class name to add to the component
 * @param {string} testId - optional test id to add to the component, needed as a prop for testing multiple annotations at once
 */
const LegalAnnotation: FC<Props> = ({legalKey, className, testId = `legal-annotation-component`}: Props) => {
  const { legal } = useSelector((store: ReduxState) => store);
  const {activeLegal = []} = legal || {};
  const [stateAnnotation, setAnnotation] = useState<number | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const reduxAnnotation = activeLegal.indexOf(legalKey);

    if(stateAnnotation == reduxAnnotation) return;
    if (reduxAnnotation > -1) {
      setAnnotation(reduxAnnotation+1);
    } else {
      // This legal hash is not in the active arr yet, add it
      dispatch(addActiveLegal([legalKey]));
    }
  }, [legalKey, activeLegal]);

  return <sup className={className} data-testid={testId}>[{stateAnnotation}]</sup>;
}

export default LegalAnnotation;

LegalAnnotation.displayName = 'Legal Annotation';
